import React from 'react';
import SelectionContext from '../../contexts/SelectionContext';
import FavoriteTournamentToggle from '../favorite-tournaments/FavoriteTournamentToggle';

function SelectionTournament(props) {
    const selectionContext = React.useContext(SelectionContext);

    let checked = selectionContext.tournaments.indexOf(props.uniqueId) !== -1;

    function handleOnChange() {
        selectionContext.toggleTournament(props.uniqueId);
    }

    return (
        <li>
            <div className="custom-control custom-checkbox d-flex">
                <FavoriteTournamentToggle className="mr-5 pointer" uniqueId={props.uniqueId} />
                <input type="checkbox" className="custom-control-input" id={"xs-selection-" + props.id} onChange={handleOnChange} checked={checked} />
                <label className="custom-control-label d-flex pointer" htmlFor={"xs-selection-" + props.id}>
                    {props.descrizione}
                    {props.isLive &&
                        <span className="live-badge ml-1 mr-auto"></span>
                    }
                </label>
            </div>
        </li>
    );
}

export default SelectionTournament;